module.exports = __webpack_public_path__ + "static/img/dna.9721676.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/mo/zh/dna.png
// module id = zrCs
// module chunks = 1 3